import * as echarts from 'echarts'
import { getOrgShowName } from "@/api/global.js";

export function colorData (key = 0, direction = 'RL') {
  const obj = {
    RL: [1,0,0,1],
    LR: [0,0,1,0]
  }
  const kes = obj[direction]
  // ['#80E0FF', '#FFB275', '#FCDD89', '#BE99F1', '#F199A3', '#BDDC68', '#85DBAF', '#558FE0']
  const color1 = new echarts.graphic.LinearGradient(...kes,[{offset:0, color: '#358aff'}, {offset:1, color: '#358aff'}], false)
  const color2 = new echarts.graphic.LinearGradient(...kes,[{offset:0, color: '#3ad3f9'}, {offset:1, color: '#3ad3f9'}], false)
  const color3 = new echarts.graphic.LinearGradient(...kes,[{offset:0, color: '#5266f6'}, {offset:1, color: '#5266f6'}], false)
  const color4 = new echarts.graphic.LinearGradient(...kes,[{offset:0, color: '#f29a3d'}, {offset:1, color: '#f29a3d'}], false)
  const color5 = new echarts.graphic.LinearGradient(...kes,[{offset:0, color: '#fce74e'}, {offset:1, color: '#fce74e'}], false)
  const color6 = new echarts.graphic.LinearGradient(...kes,[{offset:0, color: '#80d6ec'}, {offset:1, color: '#80d6ec'}], false)
  const color7 = new echarts.graphic.LinearGradient(...kes,[{offset:0, color: '#a997f0'}, {offset:1, color: '#a997f0'}], false)
  const color = [
    color1,
    color2,
    color3,
    color4,
    color5,
    color6,
    color7,
  ];
  const ind = key > 9 ? key - (Math.floor(key / 10) * 10) : key;
  return color[ind];
}

export const colorDataNew = ['#358aff', '#3ad3f9', '#5266f6', '#f29a3d', '#fce74e', '#80d6ec', '#a997f0']

// 可视化有列字段的解析(后台)
export function visualization ({ row, column, summary, data , seriesType }) {
  console.log('下来计算 row', row, 'column', column, 'summary', summary, 'data', data)
  let rowArr = []
  for (const r of data) {
    const item = JSON.parse(JSON.stringify(r))
    let str = ''
    for (let i = 0; i < row.length; i++) {
      let name = row[i].name
      let name1 = row[i].name + (row[i].format ? '显示格式' : '')
      str += (r[name] || r[name] === 0 ? r[name] : r[name1] || r[name1] === 0 ? r[name1] : '')
      delete item[name]
    }
    item.name = str
    rowArr.push(item)
  }
  console.log( 'rowArr----------------', rowArr );
  
  // 当系列类型为系列名时使用新算法
  if ( seriesType === 'name' ) {
    
    let columnArr = []
    // 循环列
    column.forEach( (col,index) => {
      // 获取列名
      const columnName = col.name
      // 定义数组存储对应列名数据
      let _arr = []
      // 循环行 row为对象
      rowArr.forEach( row => {
        let a = { name: row.name, key: columnName }
        if(index === 0)a.seriesType = seriesType
        let arr = Object.keys( row )
        arr.forEach( i => {
          if(i.includes(columnName +'(')){
            a[i] = row[i]
          }
        } )
        _arr.push(a)
      })
      columnArr.push(_arr)
    } );
    console.log('columnArr------',columnArr);
    return columnArr
  } else {
    let columnArr = [[]]
    const columnName = getFieldName(column[0], 'column')
    const nameCount = getGroupingCount(rowArr, columnName)
    for (const r of rowArr) {
      const i = columnArr[0].findIndex(its => its[columnName] === r[columnName])
      if (i === -1) {
        columnArr[0].push(r)
      } else {
        // 判断现在位数是否一样，不一样的话补足
        const len = nameCount[r[columnName]] > columnArr.length ? nameCount[r[columnName]] : columnArr.length
        for (let s = 1; s < len; s++) {
          if (!columnArr[s] || typeof columnArr[s] !== 'object') columnArr[s] = []
          const ci = columnArr[s].findIndex(its => {
            return its && its[columnName] === r[columnName]
          })
          if (ci === -1) {
            columnArr[s][i] = r
            break
          }
        }
      }
    }
    return columnArr
  }
}

function getGroupingCount (arr, key) {
  const obs = {}
  for (const i of arr) {
    obs[i[key]] = obs[i[key]] ? obs[i[key]] + 1 : 1
  }
  return obs
}
export function getFieldName (item, key = 'row') {
  console.log(key, 'key')
  if (!item) return ''
  let str = item.name || item.revisabilityName
  // let str = key === 'row' ? (item.revisabilityName || item.name) : item.name
  // if (item.format && (item.type === 'date' || item.type === 'number')) {
  //   str += '显示格式'
  // }
  return str
}

// 可视化解析（客户端查看）
export function visualizationClient ( { row, column, summary, date, type , seriesType } ) {
  console.log('可视化解析（客户端查看）','date',date,'row',row,'column',column,'summary',summary,'seriesType',seriesType);
  if ( seriesType === 'name' ) {
    let rowNames = []
    row.forEach( item =>{
      rowNames.push(item.name)
    })
    let columnArr = []
    // 循环列
    summary.forEach( (s,index) => {
      // 获取列名
      const columnName = s.name1
      // 获取汇总名
      const sname = s.name
      // 获取计算类型
      let m = sname.search(/\(/)
      let n = sname.search( /\)/ )
      const summaryType = sname.slice( m + 1, n )
      // 定义数组存储对应列名数据
      let _arr = []
      // 循环行 d为对象
      console.log(columnName,summaryType);
      date.forEach( d => {
        let rowName = ''
        rowNames.forEach( item => {
          rowName += d[item]
        })
        let a = { name: rowName, key: columnName }
        if(index === 0)a.seriesType = seriesType
        let arr = Object.keys( d )
        let value = null
        let _index = 0
        arr.forEach( (i,indx) => {
          if ( i.includes( columnName + '(' ) ) {
            switch (summaryType){
              case '求和':
              case '计数':
                if(value === null) value = 0
                value += d[i]
                break
              case '求平均':
                if(value === null) value = 0
                value += d[i]
                _index++
                if(indx === i.length - 1){
                  value = value / _index
                }
                break
              case '求最大值':
                if(value === null) value = d[i]
                value = value > d[i] ? value : d[i]
                break
              case '求最小值':
                if ( value === null ) value = d[i]
                console.log(value);
                value = value < d[i] ? value : d[i]
                break
            }
          }
        })
        a[sname] = value
        _arr.push(a)
      })
      columnArr.push(_arr)
    } );
    console.log('columnArr------',columnArr);
    return columnArr
  }
  for (let i = 0; i < date.length; i++) {
    const item = JSON.parse(JSON.stringify(date[i]))
    let str = ''
    for (const r of row) {
      const name = getFieldName(r, 'row')
      let value = item[name] || item[name] === 0 ? item[name] : ''
      if (Array.isArray(value) && (value[0] && (value[0].name || value[0].realname))) {
        value = value.map(item => {
          if (item && item.organizationId) {
            return getOrgShowName(item)
          } else {
            return item.name || item.realname
          }
        }).join()
      }

      str += ((!str && str !== 0 ? '' : '\u0001') + value)
      delete item[name]
    }
    item.name = str
    date[i] = item
  }
  const columnArr = [[]]
  const columnName = getFieldName(column[0])
  const getCount = getGroupingCountClient(date)
  for (const i of date) {
    if (i) {
      let keyArr = Object.keys(i)
      // keyArr 根据column 去除多summary
      if (type === 'timeline' && summary.length > 1) {
        const keys = {}
        for (const s of keyArr) {
          const val = s.split(/\1{1}/g)[0]
          if (!keys[val]) keys[val] = s
        }
        keyArr = Object.values(keys)
      }
      if (column && column[0] && column[0].sort && column[0].sort.value && Array.isArray(column[0].sort.value) && column[0].sort.value.length > 0) {
        const keyArr1 = []
        for (const a of column[0].sort.value) {
          for (const s of keyArr) {
            const val = s.split(/\1{1}/g)[0]
            if (val === a) {
              keyArr1.push(s)
              break
            }
          }
        }
        keyArr = keyArr1
      }
      for (const s of keyArr) {
        if (s !== 'name') {
          const val = s.split(/\1{1}/g)
          if (column && column[0] && column[0].type === 'status') val[0] = getStatus(val[0])
          const index = columnArr[0].findIndex(its => its[columnName] === val[0])
          const sItem = {
            name: i.name
          }
          sItem[columnName] = val[0]
          sItem[val[1]] = i[s]
          if (type === 'candlestick' || type === 'timeline') {
            if (summary.length > 1) {
              for (const sz of summary) {
                const ti = val[0] + '\u0001' + sz.name
                if (i[ti]) sItem[ti] = i[ti]
              }
            }
          }
          if (type === 'radar' && column && column.length > 0) {
            for (let ci = 0; ci < column.length; ci++) {
              sItem[column[ci].revisabilityName || column[ci].name] = val[ci]
            }
            sItem[val[val.length - 1]] = i[s]
          }
          if (index === -1) {
            columnArr[0].push(sItem)
          } else {
            const len = getCount[s] > columnArr.length ? getCount[s] : columnArr.length
            for (let s = 1; s < len; s++) {
              if (!columnArr[s] || typeof columnArr[s] !== 'object') columnArr[s] = []
              const ci = columnArr[s].findIndex(its => {
                return its && its[columnName] === val[0]
              })
              if (ci === -1) {
                columnArr[s][index] = sItem
                break
              }
            }
          }
        }
      }
    }
  }
  console.log('最终返回结果', columnArr)
  return columnArr
}
function getStatus (val) {
  const statObj = {
    0: '进行中',
    1: '已通过',
    2: '未通过',
    3: '已撤回'
  }
  return statObj[val] || val
}
function getGroupingCountClient (arr) {
  const obj = {}
  for (const i of arr) {
    if (i) {
      for (const s in i) {
        obj[s] = !obj[s] ? 1 : obj[s] + 1
      }
    }
  }
  return obj
}

// 统一结构解析值
export function chartParse ( { date, column, summary, xAxisData, config, colorFu, type } ) {
  console.log('date',date, 'column',column, 'summary',summary,'xAxisData', xAxisData, 'config',config, 'colorFu',colorFu, 'type',type,'传入的series数据');
  // 获取系列类型
  const seriesType = date[0] && date[0][0] && date[0][0].seriesType || 'value'
  // arr 下来的值是 name 的
  const series = []
  const columnName = getFieldName(column[0])
  // 获取第一个数据转图例
  for ( let i = 0; i < date.length; i++ ) {
    if ( seriesType === 'name' ) {
        // 拿到第一项
      const item = date[i]
      const obj = JSON.parse( JSON.stringify( config ) )
      obj.name = item[0].key
      obj.data = new Array(xAxisData.length).join('.').split('.')
      if (obj.itemStyle && obj.itemStyle.normal && obj.itemStyle.normal.color && colorFu) {
        obj.itemStyle.normal.color = typeof colorFu === 'function' ? colorFu(i) : colorRet(colorFu, i)
      }
      if (obj.lineStyle && obj.lineStyle.normal && obj.lineStyle.normal.color && colorFu) {
        obj.lineStyle.normal.color = typeof colorFu === 'function' ? colorFu(i) : colorRet(colorFu, i)
      }
      if (obj.itemStyle && obj.itemStyle.normal && obj.itemStyle.normal.areaStyle && obj.itemStyle.normal.areaStyle.color && colorFu) {
        obj.itemStyle.normal.areaStyle.color = typeof colorFu === 'function' ? colorFu(i) : colorRet(colorFu, i)
      }
      let value = new Array( xAxisData.length ).fill(null)
      // 用 nameIndex 存储数据具体值的位置
      item.forEach( (data,index) => {
        const nameIndex = xAxisData.findIndex( its => its === data.name )
        // 获取计算类型 
        let _key = ''
        for ( let j = 0; j < summary.length; j++ ) {
          if ( summary[j].name1 === obj.name ) {
            _key = summary[j].name
            break
          }
        }
        let m = _key.search(/\(/)
        let n = _key.search( /\)/ )
        const summaryType = _key.slice( m + 1, n )
        // 定义数组存储对应行名数据
        // 判断计算类型并计算
        switch (summaryType){
          case '求和':
          case '计数':
            if(value[nameIndex] === null) value[nameIndex] = 0
            value[nameIndex] += data[_key]
            break
          case '求平均':
            value[nameIndex] += data[_key]
            if(index === item.length - 1){
              value[nameIndex] = value[nameIndex] / item.length
            }
            break
          case '求最大值':
            if(value[nameIndex] === null) value[nameIndex] = data[_key]
            value[nameIndex] = value[nameIndex] > data[_key] ? value[nameIndex] : data[_key]
            break
          case '求最小值':
            if(value[nameIndex] === null) value[nameIndex] = data[_key]
            value[nameIndex] = value[nameIndex] < data[_key] ? value[nameIndex] : data[_key]
            break
        }
      } )
      obj.data = value
      series.push(obj)
    } else {
      const item = date[i]
      // 第一条总是最完善的
      if (Array.isArray(item)) {
        for (let a = 0; a < item.length; a++) {
          const s = item[a]
          if (!s) {
            series[a].data.push('')
            continue
          }
          if (i === 0) {
            const obj = JSON.parse(JSON.stringify(config))
            obj.name = s[columnName]
            obj.data = new Array(xAxisData.length).join('.').split('.')
            if (obj.itemStyle && obj.itemStyle.normal && obj.itemStyle.normal.color && colorFu) {
              obj.itemStyle.normal.color = typeof colorFu === 'function' ? colorFu(a) : colorRet(colorFu, a)
            }
            if (obj.lineStyle && obj.lineStyle.normal && obj.lineStyle.normal.color && colorFu) {
              obj.lineStyle.normal.color = typeof colorFu === 'function' ? colorFu(a) : colorRet(colorFu, a)
            }
            if (obj.itemStyle && obj.itemStyle.normal && obj.itemStyle.normal.areaStyle && obj.itemStyle.normal.areaStyle.color && colorFu) {
              obj.itemStyle.normal.areaStyle.color = typeof colorFu === 'function' ? colorFu(a) : colorRet(colorFu, a)
            }
            series.push(obj)
          }
          // 用 arr 查询具体值的位置
          const nameIndex = xAxisData.findIndex(its => its === s.name)
          if (nameIndex !== -1) {
            // 散列两个数据
            if (type === 'scatter') {
              if (s[summary[0].name] || s[summary[0].name] === 0) {
                series[a].data[nameIndex] = [xAxisData[nameIndex], s[summary[0].name]]
              }
            } else if (type === 'candlestick') {
              const ars = []
              for (const se of summary) {
                const summaryName = se.name
                ars.push(s[summaryName])
              }
              series[a].data[nameIndex] = ars
            } else {
              series[a].data[nameIndex] = s[summary[0].name] || ''
            }
          }
        }
      }
    }
  }
  if(type === 'timeline'){
    let barArr = [];
    for(let i = 0; i < series.length; i++){
      let num = 0;
      for(let j = 0; j < series[i].data.length; j++){
        num += Number(series[i].data[j]);
      }
      barArr.push({
        name: series[i].name,
        value: num,
        type: 'bar'
      })
    }
    series.push({
      data: barArr
    })
  }
  return series
}

function colorRet (color, key) {
  const len = key > color.length ? key - (Math.floor(key / color.length) * 10) : key;
  return color[len]
}

// 雷达图解析
export function chartRadar ({ date, column, summary, xAxisData }) {
  // arr 下来的值是 name 的
  const series = []
  const columnName = getFieldName(column[0])
  // 获取第一个数据转图例
  for (let i = 0; i < date.length; i++) {
    const item = date[i]
    // 第一条总是最完善的
    if (Array.isArray(item)) {
      for (let a = 0; a < item.length; a++) {
        const s = item[a]
        if (!s) {
          continue
        }
        if (i === 0) {
          const obj = {}
          obj.name = s[columnName]
          obj.value = new Array(xAxisData.length).join('.').split('.')
          obj.value = obj.value.map(its => !its ? 0 : its)
          series.push(obj)
        }
        // 用 arr 查询具体值的位置
        const nameIndex = xAxisData.findIndex(its => its === s.name)
        if (nameIndex !== -1) {
          series[a].value[nameIndex] = s[summary[0].name] || ''
        }
      }
    }
  }
  console.log('返回雷达配置', series)
  return series
}
